import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { IpadShell } from './layout/IpadShell';
import { Layout } from './layout/Layout';
import { MonitorScreen } from './screens/MonitorScreen';
import { RunupScreen } from './screens/RunupScreen';
import { SettingsScreen } from './screens/SettingsScreen';
import { TroubleshootScreen } from './screens/TroubleshootScreen';
import { WizardScreen } from './screens/WizardScreen';
import { EngineStoreProvider } from './state/engineStore';

export function App() {
  return (
    <EngineStoreProvider>
      <IpadShell>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route index element={<Navigate to="/wizard" replace />} />
              <Route path="/wizard" element={<WizardScreen />} />
              <Route path="/monitor" element={<MonitorScreen />} />
              <Route path="/runup" element={<RunupScreen />} />
              <Route path="/troubleshoot" element={<TroubleshootScreen />} />
              <Route path="/settings" element={<SettingsScreen />} />
              <Route path="*" element={<Navigate to="/wizard" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </IpadShell>
    </EngineStoreProvider>
  );
}
